<script>
    import "../project-card/projectCard.css";
    import {projectDetail, projectSaleDetails, tokenPurchased} from "../../store";
    import {sliceOffDecimalNumbers} from "../../utils"
    export let saleCardDetails
    export let project
    let raisedTargetpercent, hasPassedRaisedTarget,progressPercent
    $: projectHolder = project ? project : $projectDetail
    $: {
        if(projectHolder.sale_address){
            progressPercent = ((saleCardDetails.totalRaised/saleCardDetails.price)/(saleCardDetails.totalSupply))*100
            raisedTargetpercent = (saleCardDetails.raiseTarget / (saleCardDetails.totalSupply * saleCardDetails.price)) * 100
            hasPassedRaisedTarget=progressPercent >= raisedTargetpercent? 'green':'';  
        }else{
            raisedTargetpercent = (projectHolder.project_raise_target/(projectHolder.total_available_token* projectHolder.project_token_price))*100;
            hasPassedRaisedTarget = projectHolder.progress_bar_status >= raisedTargetpercent ? 'green':'';    
        }
            
    }
</script>
<div class="flex column-direction progress-wrapper">
    <span class="flex"><strong>Raised <small>${projectHolder.sale_address?sliceOffDecimalNumbers(saleCardDetails.totalRaised):sliceOffDecimalNumbers(projectHolder.total_available_token*(projectHolder.progress_bar_status/100)*projectHolder.project_token_price)}</small></strong>
        <small class="ml-auto">{projectHolder.sale_address?((saleCardDetails.totalRaised/saleCardDetails.price) ? sliceOffDecimalNumbers(saleCardDetails.totalRaised/saleCardDetails.price) : 0) :sliceOffDecimalNumbers(projectHolder.total_available_token*(projectHolder.progress_bar_status/100))}/{projectHolder.sale_address?sliceOffDecimalNumbers(saleCardDetails.totalSupply):sliceOffDecimalNumbers(projectHolder.total_available_token)}</small>
    </span>
    <section class="flex">
        <span style={`left: ${raisedTargetpercent >= 100 ? "100" : raisedTargetpercent }%`} class="progress-raise-target"></span>

        {#if  !projectHolder.sale_address}
        <span style={`width: ${projectHolder.progress_bar_status >= 100 ? "100" : projectHolder.progress_bar_status }%`} class="{`progress-thumb ${hasPassedRaisedTarget}`}"></span>
        <small class="percentage-text">{projectHolder.progress_bar_status >= 100 ? "100" : projectHolder.progress_bar_status}%</small>
        {:else}
        <span style={`width: ${progressPercent >= 100 ? "100" : progressPercent }%`} class="{`progress-thumb ${hasPassedRaisedTarget}`}"></span>
        <small class="percentage-text">{progressPercent >= 100 ? "100" : sliceOffDecimalNumbers(progressPercent)}%</small>
        {/if}
    </section>
</div>
<style>
    .progress-wrapper {
        width: 100%;
        margin: 5px 0 0;
        color: #fff;
    }
    .progress-wrapper > span { margin: 0 0 5px}
    .progress-wrapper > span strong small { font-weight: 400}
    .progress-wrapper section {
        width: 100%;
        background: rgba(228, 228, 228, 0.25);
        height: 25px;
        border-radius: 50px;
        padding: 0;
        overflow: hidden;
        position: relative;
    }
    .progress-thumb {
        position: absolute;
        left: 0;
        border-radius: 50px;
        top: 0;
        height: 100%;
        background: #C21225;
        overflow: hidden;
    }
    .progress-thumb.green {
        background: green;
    }
    .percentage-text {
        position: absolute;
        right: 13px;
        top: 0;
        bottom: 0;
        font-size: 11px;
        font-weight: 400;
        display: flex;
        align-items: center;
    }
    .progress-raise-target {
        position: absolute;
        top: 0;
        bottom: 0;
        height: 100%;
        width: 5px;
        background: rgba(0,0,0,0.5);
        z-index: 1;
    }
</style>
